import React from 'react';
import './DevelopmentTools.css';

function DevelopmentToolsPL({ onNavigate, isFirst, isLast }) {
  return (
    <div className="use-case-container">
      {/* Optional overall heading */}
      <div className="use-case-header">
        <h3 className="use-case-title">
          Development Tools / narzędzie „Menu configuration”
        </h3>
        <div className="navigation-buttons">
          <button
            onClick={() => onNavigate('prev')}
            disabled={isFirst}
            className="nav-button"
          >
            &lt;
          </button>
          <button
            onClick={() => onNavigate('next')}
            disabled={isLast}
            className="nav-button"
          >
            &gt;
          </button>
        </div>
      </div>

      {/* Overview */}
      <div id="devtools-overview" className="use-case-section">
        <h2 className="section-title">Przegląd</h2>
        <div className="overview-content">
          <p>
            W roli UX designera <strong>prowadziłam redesign aplikacji developerskiej dla logistyki</strong>, aby zwiększyć jej użyteczność i efektywność. Kluczowe osiągnięcia:
          </p>
          <ul className="overview-list">
            <li>
              <strong>Optymalizacja narzędzi:</strong> Identyfikacja i eliminacja problemów użytkowników w celu usprawnienia workflowów developerskich.
            </li>
            <li>
              <strong>Nowoczesny interfejs:</strong> Zaprojektowanie intuicyjnego interfejsu wspierającego elastyczną, zorientowaną na użytkownika konfigurację.
            </li>
            <li>
              <strong>Współpraca zespołowa:</strong> Ścisła współpraca z <strong>zespołami developerskimi</strong> i <strong>Product Ownerem</strong>, by zapewnić zgodność z potrzebami użytkowników i celami biznesowymi.
            </li>
          </ul>
        </div>
      </div>

      {/* Specification */}
      <div id="devtools-specification" className="use-case-section">
        <h2 className="section-title">Specyfikacja</h2>
        <div className="specification-content">
          <h1 className="tool-name">Narzędzie „Menu configuration”</h1>
          <div className="spec-details">
            <div className="spec-row">
              <div className="spec-label">Czas trwania:</div>
              <div>1 rok</div>
            </div>
            <div className="spec-row">
              <div className="spec-label">Wykorzystane narzędzia:</div>
              <div>Figma, Confluence, Jira, FigJam</div>
            </div>
          </div>
          <div>
            <h3 style={{ color: '#0074f0', marginBottom: '0' }}>Cel</h3>
            <p className="goal-text">
              Usprawnienie narzędzia w aplikacji developerskiej, które umożliwia zespołowi wdrożeniowemu szybkie i skuteczne konfigurowanie menu biznesowych.
            </p>
          </div>
          <img
            src={require("../../../../assets/use-case-specification.png")}
            alt="Ilustracja specyfikacji use case"
            className="specification-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginTop: '2rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
        </div>
      </div>

      {/* The Problem */}
      <div id="devtools-problem" className="use-case-section">
        <div className="problem-header">
          <h2 className="section-title">
            <span className="highlight-blue">Problem</span> – wyzwanie
          </h2>
        </div>
        <div className="problem-content">
          <p>
            Głównym wyzwaniem było objęcie roli <strong>Lead UX/UI Designera</strong> i odpowiedzialność za cały proces UX oraz dostarczenie finalnego UI.
          </p>
          <p>
            W tym projekcie przeprowadziłam <strong>weryfikację potrzeb użytkowników</strong> i <strong>optymalizację istniejącego narzędzia</strong> pod kątem przyszłego rozwoju. Moja rola obejmowała <strong>identyfikację pain points</strong>, zrozumienie wymagań użytkowników oraz <strong>uproszczenie struktury organizacyjnej</strong> narzędzia, by zapewnić intuicyjne i płynne doświadczenie. Skupiłam się na tworzeniu skutecznych, zorientowanych na użytkownika rozwiązań, które rozwiązywały kluczowe problemy i znacząco poprawiały całościowe doświadczenie.
          </p>
          <div className="impact-section">
            <h3 className="highlight-blue">Mój wpływ</h3>
            <p>Wybrane notatki, najważniejsze punkty i rezultaty projektu:</p>
            <ul className="impact-list">
              <li>
                <strong>Wykorzystanie danych</strong> z <strong>badań</strong> do tworzenia narzędzi przyjaznych różnym grupom użytkowników.
              </li>
              <li>
                <strong>Transformacja funkcji narzędzia</strong> na bardziej <strong>praktyczne</strong> i wartościowe rozwiązania.
              </li>
              <li>
                <strong>Redesign interfejsu</strong> zgodnie z <strong>brand guidelines</strong>, zapewniając spójność wizualną i użyteczność.
              </li>
              <li>
                Udział w wewnętrznych review i wdrażanie <strong>feedbacku</strong>.
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* The Process */}
      <div id="devtools-process" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue">Proces</span> – podejście
        </h2>
        <div className="process-content">
          <p>
            Przedstawiłam kluczowe etapy procesu projektowego i podkreśliłam zasady UX oraz wiedzę wykorzystaną na każdym etapie.
          </p>

          <h3 className="highlight-blue">Wywiady pogłębione z użytkownikami</h3>
          <p>Przeprowadziłam kilka wywiadów, aby zrozumieć:</p>
          <ul className="process-list">
            <li>
              <strong>Różne konteksty biznesowe</strong>, w których narzędzie jest wykorzystywane do konfiguracji menu (cele).
            </li>
            <li>
              <strong>Wzorce developerskie</strong> związane z procesem konfiguracji (krok po kroku).
            </li>
            <li>
              Najważniejsze <strong>problemy z użytecznością</strong>, z jakimi mierzą się użytkownicy.
            </li>
            <li>
              Które <strong>funkcje są kluczowe</strong> i jak stworzyć przejrzystą hierarchię funkcji.
            </li>
          </ul>

          <h3 className="highlight-blue">Analiza konkurencji</h3>
          <ul className="process-list">
            <li>
              Przeanalizowałam <strong>najlepiej oceniane aplikacje</strong> podobne do naszej, by <strong>porównać kluczowe funkcje</strong> i rozwiązania dla konfiguracji menu.
            </li>
            <li>
              Skupiłam się na <strong>identyfikacji najlepszych praktyk</strong> i rozwiązań.
            </li>
          </ul>

          <h3 className="highlight-blue">Persona</h3>
          <ul className="process-list">
            <li>
              Po uporządkowaniu wyników badań opracowałam personę, która najlepiej <strong>reprezentuje główną grupę użytkowników</strong>.
            </li>
          </ul>

          <h3 className="highlight-blue">User stories</h3>
          <ul className="process-list">
            <li>
              Główny use case powstał na podstawie syntezy badań z wywiadów i analizy konkurencji, podkreślając wyzwania narzędzia. <strong>MVP</strong> (Minimum Viable Product) skupia się na <strong>kluczowych funkcjach</strong> niezbędnych do efektywnej konfiguracji menu – stąd wykorzystanie user stories.
            </li>
          </ul>

          <h3 className="highlight-blue">User flow</h3>
          <ul className="process-list">
            <li>
              Po zdefiniowaniu funkcji aplikacji <strong>zaprojektowałam task flows</strong>, które opisują <strong>główne interakcje użytkownika</strong>. Użytkownik przechodzi przez <strong>proces krok po kroku</strong> konfiguracji menu z funkcją submenu od uruchomienia aplikacji.
            </li>
          </ul>
        </div>
      </div>

      {/* The Solution */}
      <div id="devtools-solution" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue">Rozwiązanie</span> – ideacja
        </h2>
        <div className="solution-content">
          <img
            src={require("../../../../assets/solution-ideation.png")}
            alt="Ilustracja ideacji rozwiązania"
            className="solution-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginBottom: '1.5rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
          <p>
            Prowadziłam proces ideacji, bezpośrednio odpowiadając na <strong>zidentyfikowane pain points</strong> i projektując innowacyjne, <strong>przyjazne użytkownikowi rozwiązania</strong>. Każde rozwiązanie zostało zaprojektowane tak, by <span className="highlight-blue">zwiększać użyteczność</span>, <span className="highlight-blue">usprawniać workflowy</span> i znacząco poprawiać doświadczenie użytkownika. Moje podejście gwarantowało, że <strong>potrzeby użytkowników były priorytetem</strong>, a rozwiązania były zgodne z celami projektu i biznesu.
          </p>

          <h3 className="highlight-blue">Architektura informacji i podejście badawcze</h3>
          <p>
            Skupiłam się na <strong>architekturze informacji</strong>, by treści były zorganizowane logicznie i intuicyjnie, co ułatwia użytkownikom odnalezienie i zrozumienie informacji.
          </p>
          <p>Moje podejście:</p>
          <ul className="solution-list">
            <li><strong>Uproszczenie złożoności</strong> przez efektywne kategoryzowanie i grupowanie.</li>
            <li>Tworzenie przejrzystych, logicznych ścieżek nawigacji, by <strong>zmniejszyć</strong> obciążenie poznawcze.</li>
            <li>Zwiększenie użyteczności przez <strong>eliminację</strong> powielonych lub <strong>zbędnych treści</strong>.</li>
            <li><strong>Usprawnienie współpracy</strong> i procesu developmentu.</li>
          </ul>

          <div className="card-sorting-section">
            <h3 className="highlight-blue">Card Sorting</h3> z <span className="highlight-blue">Optimal Workshop</span>
            <img
              src={require("../../../../assets/card-sorting.png")}
              alt="Ilustracja card sorting"
              className="card-sorting-image"
              style={{ 
                width: '100%', 
                maxWidth: '600px', 
                marginBottom: '1.5rem',
                borderRadius: '4px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
              }}
            />
            <p>
              Korzystając z <strong>Optimal Workshop</strong>, przeprowadziłam card sorting, by zrozumieć, jak użytkownicy kategoryzują i organizują informacje. To <strong>ujawniło niejasne, powielone lub brakujące elementy</strong> i dostarczyło kluczowych insightów do poprawy nawigacji i udoskonalenia projektu narzędzia.
            </p>
            <p>
              Proces ten doprowadził do struktury zorientowanej na użytkownika, która <strong>zwiększyła funkcjonalność</strong> i użyteczność narzędzia.
            </p>
          </div>
        </div>
      </div>

      {/* Design Features */}
      <div id="devtools-designfeatures" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue">Cechy projektu</span> – wizualizacja
        </h2>
        <div className="design-features-content">
          <h3 className="highlight-blue">Lo-fi wireframes</h3>
          <img
            src={require("../../../../assets/lofi-wireframes.png")}
            alt="Ilustracja lo-fi wireframes"
            className="wireframe-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginBottom: '1.5rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
          <p>
            Tworzyłam prototypy low-fidelity, by szybko zwizualizować user flow, co pozwoliło wcześnie wykryć problemy z nawigacją i interakcją. Skupiając się na <strong>układzie, strukturze</strong> i <strong>funkcjonalności</strong> zamiast na warstwie wizualnej, <strong>priorytetowo traktowałam kluczowe doświadczenie użytkownika</strong> i dbałam o solidne fundamenty projektu przed przejściem do szczegółowych makiet.
          </p>
          <p>
            Takie podejście umożliwiło <strong>szybką iterację</strong>, efektywne testowanie pomysłów 1:1 z użytkownikami i wczesne rozwiązywanie problemów.
          </p>

          <h3 className="highlight-blue">Hi-fi wireframes</h3>
          <img
            src={require("../../../../assets/hifi-wireframes.png")}
            alt="Ilustracja hi-fi wireframes"
            className="wireframe-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginBottom: '1.5rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
          <p>Odegrałam kluczową rolę w tworzeniu prototypów high-fidelity, które oddały wizję produktu.</p>

          <h3 className="highlight-blue">Moje wkłady obejmowały:</h3>
          <ul className="contributions-list">
            <li>
              <strong>Opracowanie szczegółowej wizji produktu:</strong> Stworzyłam kompleksową wizję, zapewniając zgodność z potrzebami użytkowników i celami biznesowymi.
            </li>
            <li>
              <strong>Dostarczanie precyzyjnych prototypów:</strong> Przygotowałam dokładne prototypy, które służyły jako wzorzec dla developerów, minimalizując nieporozumienia i zapewniając poprawną implementację.
            </li>
            <li>
              <strong>Przekazywanie czytelnych wizualizacji i interakcji:</strong> Dostarczałam przejrzyste projekty graficzne i elementy interaktywne, by developerzy mogli łatwo zatwierdzić kierunek projektu.
            </li>
            <li>
              <strong>Wspieranie wartościowego feedbacku:</strong> Tworzyłam prototypy, które umożliwiały zbieranie wartościowych opinii i spełniały oczekiwania użytkowników.
            </li>
          </ul>
          <p>
            Dzięki mojej pracy projekt był zorientowany na użytkownika i zgodny z celami biznesowymi. Dodatkowo <strong>zaktualizowałam schemat kolorystyczny</strong>, by <strong>zgodny był z brand guidelines</strong>, zapewniając spójny i profesjonalny wygląd oraz lepszą użyteczność. Starannie dobrałam kolory, by były zgodne z identyfikacją wizualną, <strong>poprawiły czytelność i zminimalizowały rozpraszacze wizualne</strong>.
          </p>
        </div>
      </div>

      {/* Conclusion */}
      <div id="devtools-conclusion" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue">Podsumowanie</span>
        </h2>
        <div className="conclusion-content">
          <p>
            <strong>Prowadzenie tego projektu UX</strong> polegało na konfiguracji menu pod różne potrzeby użytkowników. Dzięki badaniom i rozwiązywaniu problemów <strong>zidentyfikowałam kluczowe wyzwania</strong>, zwłaszcza sztywność <strong>pierwotnego narzędzia</strong>. Wdrożone rozwiązania <strong>przekształciły je w bardziej efektywny system</strong>, zwiększając satysfakcję developerów.
          </p>
          <p>
            <strong>Współpraca z developerami</strong> pokazała, jak ważna jest <strong>dobrze zaprojektowana architektura systemu</strong>. To partnerstwo pogłębiło moje zrozumienie, jak <strong>przemyślany design</strong> prowadzi do <strong>intuicyjnych interfejsów</strong>. Połączenie zasad UX z planowaniem architektury pozwoliło stworzyć system spełniający potrzeby użytkowników i ułatwiający rozwój.
          </p>
          <p>
            To doświadczenie wzmocniło wartość wczesnego uwzględniania UX w procesie projektowym. <strong>Nauczyło mnie ufać badaniom</strong>, słuchać użytkowników, dostosowywać się do ich potrzeb i znajdować <strong>kreatywne rozwiązania złożonych problemów</strong>. Zarządzanie wielopoziomowym developmentem i zbieranie informacji od różnych interesariuszy <strong>poprawiło moje umiejętności organizacyjne i liderskie</strong>.
          </p>
          <p>
            Ta <strong>droga pokazała złożoność prowadzenia projektów UX</strong> i konieczność równoważenia potrzeb użytkowników z ograniczeniami technicznymi. Podkreśliła wagę <strong>efektywnej komunikacji</strong> i <strong>współpracy zespołów cross-functional</strong>, by osiągnąć harmonię między user-centered design a architekturą systemu.
          </p>
        </div>
      </div>
    </div>
  );
}

export default DevelopmentToolsPL; 